
define('text!templates/admin_menu_link.html',[],function () { return '<li class="<%=link.className%> <% if (link.isActive) print(\'isactive\'); %>" id="<%=link.id%>">\n    <a href="<%=link.href%>"><%=link.title%><% if (link.indicator > 0) print(\' (\' + link.indicator + \')\'); %></a>\n</li>';});

